import { sendContainerRequest } from '@/container'

export async function getUserDisplayDataByEmail(email) {
    const data = { email }
    return sendContainerRequest('getUserDisplayDataByEmail', data).then(
        (result) => result.data
    )
}
